import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { OktaAuthModule } from '@okta/okta-angular';
import {
  ClientAppIdInterceptor,
  DEFAULT_TIMEOUT,
  TokenInterceptor,
} from './interceptors';
import { AUTH_OKTA_MODULE_CONFIG } from './services/auth-okta-module-config';
import { AuthOktaConfig } from './types/auth-okta-config';

@NgModule({
  imports: [OktaAuthModule],
})
export class FeatureAuthOktaModule {
  static forRoot(
    config: AuthOktaConfig
  ): ModuleWithProviders<FeatureAuthOktaModule> {
    return {
      ngModule: FeatureAuthOktaModule,
      // It is important that http interceptors are never dependant (even indirectly) of the configuration
      providers: [
        [{ provide: AUTH_OKTA_MODULE_CONFIG, useValue: config }],
        [
          {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
          },
          {
            provide: HTTP_INTERCEPTORS,
            useClass: ClientAppIdInterceptor,
            multi: true,
          },
        ],
        [{ provide: DEFAULT_TIMEOUT, useValue: 15000 }],
      ],
    };
  }
}
